var OrganizationPlaceholder, selectOrganization;

import HierarchicalSelect from 'trunks/vue/admin/components/libs/hierarchical_select_organization.js';

import SearchMixin from 'trunks/vue/admin/components/search/mixin.js';

OrganizationPlaceholder = '请选择';

export default selectOrganization = Vue.extend({
  mixins: [SearchMixin],
  components: {
    'hierarchical-select': HierarchicalSelect
  },
  props: {
    userBoundary: Object,
    resources: {
      type: String,
      default: '/admin/organizations'
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      organization_ids: this.userBoundary.organization_ids || [],
      selectedNode: null
    };
  },
  template: `<div class="select-wrapper">
  <h4>名义组织: </h4>
  <div class="justify-box organizations-search-wrapper">
    <div class="content">
      <Popover position='bottom'
              :caret='false'
              :blockContent='true'
              :loadContent='true'
              :manualToggle='true'
              @triggerClicked='triggerClicked'
              ref='popoverVm'>
        <template slot='trigger'>
          <div class="field-input-container">
            <div class="field-input">
              <div class="field-value">
                <div class="selected-node" :class="selectedNodeClass">{{ selectedOrganizationName }}</div>
              </div>
              <div class="select-caret">
                <i class="slp-caret-down placeholder"></i>
              </div>
            </div>
            <div class="error-message"></div>
          </div>
        </template>
        <div class='hierarchical-select-wrapper' slot='content'>
          <hierarchical-select
            :resources='resources'
            :initNodes='initialSelectedOrganizationIds'
            @selectedNodeChange='selectedNodeChange'
            ref='organizationsSelect' />
        </div>
      </Popover>
    </div>
  </div>
</div>`,
  computed: {
    initialSelectedOrganizationIds: function() {
      return _.map(this.organization_ids, function(id) {
        if (/\+$/.test(id)) {
          return id;
        } else {
          return parseInt(id);
        }
      });
    },
    selectedNodeClass: function() {
      if (this.selectedNode) {
        return '';
      } else {
        return 'placeholder';
      }
    },
    selectedOrganizationName: function() {
      if (this.selectedNode) {
        return this.selectedNode.name;
      } else {
        return OrganizationPlaceholder;
      }
    }
  },
  methods: {
    selectedNodeChange: function(node) {
      this.selectedNode = node;
      this.$emit('selectedNodeChange', node);
      return this.$refs.popoverVm.close();
    },
    triggerClicked: function(event) {
      return this.$refs.popoverVm.open();
    }
  }
});
